module.exports = __webpack_public_path__ + "pushover.206bdd.svg";